import React, { Component } from 'react';
import { Form, Input, Button, Checkbox, message } from 'antd';
import styles from './index.less';
import * as API from '@/services';
import Cookies from 'js-cookie'
import { dispatch } from '@@/store';
const newIptStyle = {
    borderTop: 'none', 
    borderLeft: 'none', 
    borderRight: 'none', 
    boxShadow: 'none',
    borderRadius: '0px'
}
 const Uppwd = () => {
    const [loginForm] = Form.useForm();
    const onFinish = (values) => {
        console.log('Success:', values);
    };

    const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };
   
    const changePwd = () => {
        loginForm.validateFields().then(res=>{
            //13111210001
            API.getAuthZ({token: Cookies.get('_security_token')}).then(data => {
                if (data && data.ssoLogin) {
                    API.findStaffAccountByCondition({staffKeyWord: data.ssoLogin.userPhone, page: 1,pageSize: 20, staffShopCode: data.ssoLogin.orgId, token: Cookies.get('_security_token')}).then(data => {
                        API.updateAccountPassword({
                            ...res,
                            accountCode: data.items[0].accountCode,
                            status: 3,
                            token: Cookies.get('_security_token')
                        }).then(data => {
                            message.success('密码修改成功，请重新登录');
                            dispatch.router.push({
                                path: '/Login',
                                query: {}
                            });
                        })
                    })
                }
            })
        });
    }

    return (
        <div className={styles.uppwdWrap}>
            <p>修改密码</p>
            <Form
                form={loginForm}
                style={{ width: '40%' }}
                initialValues={{ remember: true }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
            >
                {/* <Form.Item
                    name="group"
                    label="当前密码"
                    rules={[{ required: true, message: '请输入旧密码' }]}
                >
                    <Input.Password placeholder="请输入原密码" style={newIptStyle}/>
                </Form.Item> */}
                <Form.Item
                    name="newPassword"
                    label="新密码"
                    rules={[{ required: true, message: '请输入新密码' }]}
                >
                    <Input.Password minLength="8" placeholder="至少8位" style={newIptStyle}/>
                </Form.Item>

                <Form.Item
                    name="newConfirmPassword"
                    label="确认新密码"
                    rules={[{ required: true, message: '请输入新密码' }]}
                >
                    <Input.Password  minLength="8" placeholder="请在输入一次密码" style={newIptStyle}/>
                </Form.Item>
                <Form.Item >
                    <Button type="primary" size="large" onClick={changePwd} style={{ width: '100%', background: '#1D48F5' }}>
                        确认修改密码
                    </Button>
                </Form.Item>
            </Form>
        </div>
    );
}

export default Uppwd;